import { DataPoint, Layout } from "@npco/zeller-design-system";
import {
	useForm,
	bindField,
	zPhoneNumber,
} from "@npco/zeller-design-system/form";
import * as Input from "@npco/zeller-design-system/input";
import { ADT } from "pb.adt";
import { z } from "zod";

import { formatCurrency } from "../../../../../@lib-i18n";
import { Layout as ModalLayout } from "../../../shared/layout";
import type { Page } from "../page";

const ValuesSchema = z.object({
	phone: zPhoneNumber(),
});

export function PaymentMethodLinkSMS({
	page,
	defaultLayoutProps,
}: {
	page: Omit<ADT.Pick<Page, "PaymentMethodLinkSMS">, "$type">;
	defaultLayoutProps: Partial<ModalLayout.Props>;
}) {
	const form = useForm(ValuesSchema, async ({ value }) => {
		await page.onSubmit(value.phone);
	});
	return (
		<form.Subscribe selector={(state) => state.isSubmitting}>
			{(isSubmitting) => (
				<ModalLayout
					{...(defaultLayoutProps as ModalLayout.Props)}
					actions={[
						{ label: "Send Link", onClick: form.handleSubmit, primary: true },
						{ label: "Back", onClick: page.onBack },
					]}
					onClose={page.onClose}
					pending={isSubmitting ? "submit" : undefined}
				>
					<Layout.Container className="p-32">
						<Layout.Article>
							<DataPoint
								align="center"
								value={formatCurrency({
									amountInCents: page.total,
									currency: page.currency,
								})}
								description={
									page.surcharge
										? `incl. ${formatCurrency({
												amountInCents: page.surcharge,
												currency: page.currency,
											})} surcharge`
										: undefined
								}
							/>
							<Layout.Section>
								<form.Field
									name="phone"
									children={(field) => (
										<div
											onKeyDown={(e) =>
												e.key === "Enter" && form.handleSubmit()
											}
										>
											<Input.Phone
												{...bindField(field)}
												label="Mobile Number"
												$input={{ required: true, maxLength: 256 }}
												disabled={isSubmitting}
											/>
										</div>
									)}
								/>
							</Layout.Section>
						</Layout.Article>
					</Layout.Container>
				</ModalLayout>
			)}
		</form.Subscribe>
	);
}
